import { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import { MemberToastContext } from '../contexts/MemberToastContext';
import { GET_USER_AWARDS } from '../graphql/user/user';
import { UserEventPointsAward } from '../types/user/types';

const useCheckForPointAwards = () => {
  const { lastUserAwardTimestamp, setLastUserAwardTimestamp, showToast } =
    useContext(MemberToastContext);

  const [getUserAwards] = useLazyQuery(GET_USER_AWARDS);

  return {
    checkForPointAwards: async (dontShowToast?: boolean) => {
      setLastUserAwardTimestamp(new Date().toISOString());

      const awards =
        (
          await getUserAwards({
            variables: {
              sinceTimestamp: lastUserAwardTimestamp,
            },
          })
        ).data?.userAwards ?? [];

      const result = {
        points: 0,
        toastShown: false,
      };

      if (awards.length) {
        // Set timestamp according to the awards received
        setLastUserAwardTimestamp(
          awards.reduce(
            (acc, cur) => (cur.timestamp > acc ? cur.timestamp : acc),
            '',
          ),
        );

        const pointsAwards = awards.filter(
          // eslint-disable-next-line no-underscore-dangle
          (x) => x.__typename === 'UserEventPointsAward',
        ) as UserEventPointsAward[];

        if (pointsAwards.length) {
          result.points = pointsAwards.reduce(
            (acc, cur) => cur.points + acc,
            0,
          );

          const title =
            result.points > 1
              ? `You've earned ${result.points} points!`
              : "You've earned a point!";

          const distinctMessages = [
            ...new Set(pointsAwards.map((x) => x.awardMessage)),
          ];

          const description = distinctMessages.reduce(
            (acc, cur) =>
              `${acc}${distinctMessages.length > 1 ? ' - ' : ''}${cur}\n\n`,
            '',
          );

          if (!dontShowToast) {
            result.toastShown = true;
            showToast({
              title,
              description,
            });
          }
        }
      }

      return result;
    },
  };
};

export default useCheckForPointAwards;
